import { useEffect, useRef, useState } from 'react';
const defaultDOMRect = {
    height: 0,
    width: 0,
    x: 0,
    y: 0,
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    toJSON: () => { },
};
export const useDimensions = () => {
    const ref = useRef(null);
    const [dimensions, setDimensions] = useState(defaultDOMRect);
    useEffect(() => {
        const rect = ref && ref.current
            ? ref.current.getBoundingClientRect()
            : defaultDOMRect;
        setDimensions(rect);
    }, []);
    return [ref, dimensions];
};
//# sourceMappingURL=useDimensions.js.map
// @zapier/design-system@5.6.0 (4902ab0c1)
